export default __webpack_public_path__ + "static/tt-norms-regular-4373ae2c0c88d015be79d0221bd261a1.woff";